import { Component, Input } from '@angular/core';
import { ListDisplayCollegePath } from '../list-display-college-path/list-display-college-path.component';
import { CAREER_PATH_STATUSES } from './../../../../../shared/constants/student-paths.constant';

// ignoring tests, since they are covered in base class
/* istanbul ignore next */
@Component({
  selector: 'list-display-career-path',
  template: require('./list-display-career-path.component.html'),
  styles: [require('./../list-display-path.scss')],
})
export class ListDisplayCareerPath extends ListDisplayCollegePath {
  otherPathData; // refers to collegePath data. don't change the name since it's used in base class (dvn)
  @Input()
  set collegePathsData$(collegeData: string) {
    this.otherPathData = JSON.parse(collegeData);
  }

  finalDecisionStatuses = [CAREER_PATH_STATUSES.COMMITTED];
  iconName = 'star';
  iconColor = 'yellow';

  normalStatuses = [
    CAREER_PATH_STATUSES.PLANS_TO_APPLY,
    CAREER_PATH_STATUSES.APPLIED,
    CAREER_PATH_STATUSES.ACCEPTED,
    CAREER_PATH_STATUSES.DENIED,
  ];
}
